import React, { useState } from 'react';
import { Copy, Link as IconLink, Check, X as IconX } from 'lucide-react';
import { copyToClipboard } from '../../utils/clipboard';
import { generatePendencyId } from '../../utils/pendencyUtils';

const NewPendencyDialog = ({ isOpen, onClose, pendencyId, setModalMessage }) => {
    const [idCopied, setIdCopied] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);

    if (!isOpen) return null;

    const fullPendencyId = generatePendencyId(pendencyId);
    const shareableLink = `${window.location.origin}/?pendencyId=${pendencyId}`;

    const handleCopyId = async () => {
        const success = await copyToClipboard(fullPendencyId);
        if (success) {
            setIdCopied(true);
            setTimeout(() => setIdCopied(false), 2000);
        } else {
            setModalMessage("Falha ao copiar o ID.");
        }
    };

    const handleCopyLink = async () => {
        const success = await copyToClipboard(shareableLink);
        if (success) {
            setLinkCopied(true);
            setModalMessage("Link de compartilhamento copiado!");
            setTimeout(() => setLinkCopied(false), 2000);
        } else {
            setModalMessage("Falha ao copiar o link.");
        }
    };

    return (
        <div className="fixed inset-0 bg-black/60 z-[1050] flex justify-center items-center p-4" onClick={onClose}>
            <div className="bg-white dark:bg-slate-900 rounded-2xl shadow-2xl w-full max-w-md" onClick={e => e.stopPropagation()}>
                <header className="p-4 border-b border-slate-200 dark:border-slate-700 flex justify-between items-center">
                    <h2 className="text-xl font-bold text-slate-800 dark:text-slate-100">Pendência Criada com Sucesso!</h2>
                    <button onClick={onClose} aria-label="Fechar" className="p-2 rounded-full hover:bg-slate-200 dark:hover:bg-slate-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-offset-slate-900">
                        <IconX className="h-6 w-6" />
                    </button>
                </header>
                <div className="p-6 text-center">
                    <p className="text-slate-600 dark:text-slate-300 mb-2">O número da sua pendência é:</p>
                    <p className="text-3xl font-bold text-blue-600 dark:text-blue-400 mb-6 select-all" title="ID da Pendência">
                        {fullPendencyId}
                    </p>
                    <div className="flex justify-center items-center gap-4">
                        <button
                            onClick={handleCopyId}
                            className="btn-secondary flex items-center justify-center w-full"
                            disabled={idCopied}
                        >
                            {idCopied ? (
                                <>
                                    <Check className="mr-2 h-5 w-5 text-green-500" />
                                    ID Copiado
                                </>
                            ) : (
                                <>
                                    <Copy className="mr-2 h-5 w-5" />
                                    Copiar ID
                                </>
                            )}
                        </button>
                        <button
                            onClick={handleCopyLink}
                            className="btn-primary flex items-center justify-center w-full"
                            disabled={linkCopied}
                        >
                            {linkCopied ? (
                                <>
                                    <Check className="mr-2 h-5 w-5" />
                                    Link Copiado
                                </>
                            ) : (
                                <>
                                    <IconLink className="mr-2 h-5 w-5" />
                                    Compartilhar
                                </>
                            )}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewPendencyDialog;
